import { Injectable, EventEmitter } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ComposicaoRhProjetoService {

  composicaoRhProjetoChange = new EventEmitter();

  constructor() { }
}
